/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

import DatePicker, { utils, Day } from "react-modern-calendar-datepicker";

import "react-modern-calendar-datepicker/lib/DatePicker.css";

import classes from './CustomDatePicker.module.css';

import { useTranslation } from 'react-i18next';

import { Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import moment  from 'moment';
import usePrevious from "../../../hooks/usePrevious";
import { GLOBAL_DATE_FORMAT, BOOTSTRAP_CLASSES, isIE } from "../../../shared/utility";

const CustomDatePicker: React.FC<any> = (props) => {
  const { t } = useTranslation();

  const [selectedDayFrom, setSelectedDayFrom] = useState<Day|null>(null);
  const [selectedDayTo, setSelectedDayTo] = useState<Day|null>(null);

  const {
    value,
    setFieldValue,
    name
  } = props;

  const inputValueFromRef = useRef();
  const inputValueToRef = useRef();

  const prevValue = usePrevious(value);

  const setSelectedDaysFromValue = (currentValue: any) => {
    currentValue.forEach(function(el: IDatePickerValue) {
      const date = moment(el.value, 'YYYYMMDD', true);
      const formattedDate = {day: date.date(), month: date.month()+1, year: date.year()}
      if (el.type === "from") {
        setSelectedDayFrom(formattedDate);
      } else {
        setSelectedDayTo(formattedDate);
      }
    });
  }

  useEffect(() => {
    if (value && value.length > 0) {
      setSelectedDaysFromValue(value);
    }
  }, []);

  useEffect(() => {
    // clear form
    if (value && value.length === 0 && prevValue !== undefined && JSON.stringify(prevValue) !== JSON.stringify(value)) {
      setSelectedDayFrom(null);
      setSelectedDayTo(null);
      // @ts-ignore
      inputValueFromRef.current.value = '';
      // @ts-ignore
      inputValueToRef.current.value = '';
    } else if (value && value.length > 0 && (prevValue === undefined || prevValue.length === 0)) {
      setSelectedDaysFromValue(value);
    }
  }, [prevValue, value])

  const onInputValueChange = (evt: any, type: string) => {
    const date = moment(evt.target.value, GLOBAL_DATE_FORMAT, true)
    if (date.isValid()) {
      if (type === "from") {
        setSelectedDayFrom({day: date.date(), month: date.month()+1, year: date.year()});
      } else {
        setSelectedDayTo({day: date.date(), month: date.month()+1, year: date.year()});
      }
      setFieldValue(name, {type: type, value: date.format('YYYYMMDD')});
    }
  };

  const convertDayToString = (day: Day) => {
    return moment(`${day.day}/${day.month}/${day.year}`, 'D/M/YYYY').format(GLOBAL_DATE_FORMAT);
  }

  const onInputValueBlur = (evt: any, type: string) => {
    // @ts-ignore
    if (type === "from" && !moment(inputValueFromRef.current.value, GLOBAL_DATE_FORMAT,true).isValid()) {
      // @ts-ignore
      inputValueFromRef.current.value = "";
      setSelectedDayFrom(null);
      if (selectedDayTo === null) {
        setFieldValue(name, []);
      } else {
        setFieldValue(name, [{type: "to", value: moment(convertDayToString(selectedDayTo), GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')}])
      }
    }
    // @ts-ignore
    if (type === "to" && !moment(inputValueToRef.current.value, GLOBAL_DATE_FORMAT, true).isValid()) {
      // @ts-ignore
      inputValueToRef.current.value = "";
      setSelectedDayTo(null)
      if (selectedDayFrom === null) {
        setFieldValue(name, []);
      } else {
        setFieldValue(name, [{type: "from", value: moment(convertDayToString(selectedDayFrom), GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')}])
      }
    }
  };

  useEffect(() => {
    if (selectedDayTo === null && selectedDayFrom !== null) {
      const date = convertDayToString(selectedDayFrom);
      setFieldValue(name, [{type: "from", value: moment(date, GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')}]);
      // @ts-ignore
      inputValueFromRef.current.value = date;
    } else if (selectedDayFrom === null && selectedDayTo !== null) {
      const date = convertDayToString(selectedDayTo);
      setFieldValue(name, [{type: "to", value: moment(date, GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')}]);
      // @ts-ignore
      inputValueToRef.current.value = date;
    } else if (selectedDayFrom !== undefined && selectedDayFrom !== null
    && selectedDayTo !== undefined && selectedDayTo !== null) {
      const dateFrom = convertDayToString(selectedDayFrom);
      const dateTo = convertDayToString(selectedDayTo);
      setFieldValue(name, [
        {
          type: "from",
          value: moment(dateFrom, GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')
        },
        {
          type: "to",
          value: moment(dateTo, GLOBAL_DATE_FORMAT, true).format('YYYYMMDD')
        }
      ]);
      // @ts-ignore
      inputValueFromRef.current.value = dateFrom;
      // @ts-ignore
      inputValueToRef.current.value = dateTo;
    }
  }, [selectedDayFrom, selectedDayTo]);

  const ieAppendPlaceHolder = isIE() ? " (DD/MM/YYYYY)" : "";

  const renderCustomInput = ({ ref }: any) => (
    <Button
      style={{
              zIndex: 4,
              backgroundColor: 'transparent',
              color : '#000000'
            }}
      ref={ref}
      className="border-0 ml-n5"
      onClick={() => { ref.current?.focus(); }}>
      <FontAwesomeIcon icon={['fas', 'calendar']}/>
    </Button>
  )

  const rowClasses = [classes.calendar]
  const formControlClasses = [];

  if (props.invalid) {
    rowClasses.push(BOOTSTRAP_CLASSES.IS_INVALID);
    formControlClasses.push(BOOTSTRAP_CLASSES.IS_INVALID);
  }

  if (isIE()) {
    formControlClasses.push(classes.inputIE);
  }

  const placeholderFrom = props.placeholderFrom || t("from");
  const placeholderTo = props.placeholderTo || t("to");

  return (
    <Row className={rowClasses.join(" ")}>
    <Col>
    <InputGroup>
      <FormControl
        as="input"
        id={`${props.controlId}From`}
        onChange={(evt:any) => onInputValueChange(evt, "from")}
        onBlur={(evt:any) => onInputValueBlur(evt, "from")}
        ref={(ref: any) => inputValueFromRef.current = ref}
        className={formControlClasses.join(" ")}
        placeholder={`${placeholderFrom}${ieAppendPlaceHolder}`}
      />
      {!isIE() ? (
        <InputGroup.Append>
          <DatePicker
            renderInput={renderCustomInput}
            // inputName="from"
            maximumDate={props.maximumDate}
            minimumDate={props.minimumDate}
            locale={myCustomLocale(t)} // custom locale object
            value={selectedDayFrom}
            onChange={(val:any) => setSelectedDayFrom(val)}
          />
        </InputGroup.Append>
      ) : <></>}
    </InputGroup>
    </Col>
    <Col>
    <InputGroup>
    <FormControl
      as="input"
      id={`${props.controlId}To`}
      onChange={(evt:any) => onInputValueChange(evt, "to")}
      onBlur={(evt:any) => onInputValueBlur(evt, "to")}
      className={formControlClasses.join(" ")}
      ref={(ref: any) => inputValueToRef.current = ref}
      placeholder={`${placeholderTo}${ieAppendPlaceHolder}`}
    />
    {!isIE() ? (
      <InputGroup.Append>
        <DatePicker
          renderInput={renderCustomInput}
          // inputName="to"
          maximumDate={props.maximumDate}
          minimumDate={props.minimumDate}
          locale={myCustomLocale(t)} // custom locale object
          value={selectedDayTo}
          onChange={(val:any) => setSelectedDayTo(val)}
        />
      </InputGroup.Append>
    ) : <></>}
  </InputGroup>
  </Col>
  </Row>
  );
};

const myCustomLocale = function (t: any) {
  return {
    // months list by order
    months: [
       t('calendar.months.jan'),
       t('calendar.months.feb'),
       t('calendar.months.mar'),
       t('calendar.months.apr'),
       t('calendar.months.may'),
       t('calendar.months.jun'),
       t('calendar.months.jul'),
       t('calendar.months.aug'),
       t('calendar.months.sep'),
       t('calendar.months.oct'),
       t('calendar.months.nov'),
       t('calendar.months.dec')
    ],
    // week days by order
    weekDays: [
      {
        name: t('calendar.days.sun'), // used for accessibility
        short: t('calendar.days_short.sun'), // displayed at the top of days' rows
        isWeekend: true, // is it a formal weekend or not?
      },
      {
        name: t('calendar.days.mon'),
        short: t('calendar.days_short.mon')
      },
      {
        name: t('calendar.days.tue'),
        short: t('calendar.days_short.tue')
      },
      {
        name: t('calendar.days.wed'),
        short: t('calendar.days_short.wed')
      },
      {
        name: t('calendar.days.thu'),
        short: t('calendar.days_short.thu')
      },
      {
        name: t('calendar.days.fri'),
        short: t('calendar.days_short.fri')
      },
      {
        name: t('calendar.days.sat'),
        short: t('calendar.days_short.sat'),
        isWeekend: true,
      },
    ],

    // just play around with this number between 0 and 6
    weekStartingIndex: 0,

    // return a { year: number, month: number, day: number } object
    getToday : (gregorainTodayObject:any) => {
      return gregorainTodayObject;
    },

    // return a native JavaScript date here
    toNativeDate: (date:any) => {
      return new Date(date.year, date.month - 1, date.day);
    },

    // return a number for date's month length
    getMonthLength: (date:any) => {
      return new Date(date.year, date.month, 0).getDate();
    },

    // return a transformed digit to your locale
    transformDigit: (digit:any) => {
      return digit;
    },

    // texts in the date picker
    nextMonth: 'Next Month',
    previousMonth: 'Previous Month',
    openMonthSelector: 'Open Month Selector',
    openYearSelector: 'Open Year Selector',
    closeMonthSelector: 'Close Month Selector',
    closeYearSelector: 'Close Year Selector',
    defaultPlaceholder: 'Select...',

    // for input range value
    from: t('from'),
    to: t('to'),

    // used for input value when multi dates are selected
    digitSeparator: ',',

    // if your provide -2 for example, year will be 2 digited
    yearLetterSkip: 0,

    // is your language rtl or ltr?
    isRtl: false,
  };
}

export const calendarToday = () => {
  return utils('en').getToday();
}

export const calendarTomorrow = () => {
  return {
    year: utils('en').getToday().year,
    month: utils('en').getToday().month,
    day: utils('en').getToday().day+1
  } as Day;
}

export interface IDatePickerValue {
  type: string;
  value: string;
}

export default CustomDatePicker;
